/* unplugin-vue-components disabled */import script from "./mg-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./mg-menu.vue?vue&type=script&setup=true&lang=js"

import "./mg-menu.vue?vue&type=style&index=0&id=389c2a8c&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-389c2a8c"]])

export default __exports__